import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../weightedPriceDataSlice";
import getWeightedPricesDataApi from "../api/getWeightedPriceData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.weightedPrice;

  const pagedTrades = await dispatch(getWeightedPricesDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
